import { z } from 'zod'

/**
 * A bookable partition of a venue: a set of spaces (and, in a concurrent venue,
 * an inventory allocation) that one event books at a time. A non-concurrent
 * venue has a single track owning every space.
 */
export const eventTrackDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  sortOrder: z.number().int(),
  spaceIds: z.array(z.string().uuid()),
})

export type EventTrackDto = z.infer<typeof eventTrackDtoSchema>
